"use client";
import React, { useState } from "react";
import "@/app/serviceslist.css";
import StartTrialBtn from "../StartTrialBtnProducts";
import IndustryComponent from "@/component/AdvancedAnalytics/IndustryComponent";
import Image from "next/image";
import InsightfulDataVisualizationIco from "@/Helper/images/insightful_data_visualization.svg";
import IntegratedAdvancedAnalyticsIco from "@/Helper/images/integrated_advanced_analytics.svg";
import RealTimeMetricsDynamicDashboardsIco from "@/Helper/images/real-time_metrics_dynamic_dashboards.svg";
import StrategicInsightsAataDrivenPlanningIco from "@/Helper/images/strategic_insights_data_driven_planning.svg";



export default function AdvancedAnalytics() {
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <>
      <section className="banner_bg1 advancedanalyticsbg">
        <div className="container banner_container1">
          <div className="banner_inner">
            <div className="banner_left">
              <h1 className="banner_heading1">
                Visualize. Discover. Decide.
              </h1>
              <p className="banner_text1">
                Turn data into actionable insights with powerful BI analytics. Uncover trends, make informed
                decisions, and drive growth with clarity and confidence.
              </p>
              <div className="banner_btn_container">
                <StartTrialBtn Text={"Get Started Today"} />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="data_exploreouter">
        <div className="container">
          <div className="common_titbox common_titboxcenter"><h2 className="common_hd">We Transform Data Into Actionable Insights for Your Business</h2>
            <p className="common_desc">Our BI and analytics solutions empower you to make data-driven decisions. With customized
              reports, interactive dashboards, and predictive analytics, we help you uncover opportunities and
              stay ahead in a competitive landscape.</p>
          </div>
          <div className="data_exploreinner">
            <div className="data_explorebox">
              <h2 className="branding_head1">
                Data acquisition & collection
              </h2>
              <span className="sub_txt1">
                Building the essential data foundation for informed decisions.
              </span>
              <ul>
                <li>
                  <svg width="8" height="10" viewBox="0 0 8 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.88965 1L5.88965 5L1.88965 9" stroke="currentColor" strokeWidth="2" />
                  </svg>
                  Systematic Data Gathering: Collect data from diverse sources to create a comprehensive information base.
                </li>
                <li>
                  <svg width="8" height="10" viewBox="0 0 8 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.88965 1L5.88965 5L1.88965 9" stroke="currentColor" strokeWidth="2" />
                  </svg>
                  Data Quality Checks: Ensure data is accurate, clean, and ready for analysis.
                </li>
                <li>
                  <svg width="8" height="10" viewBox="0 0 8 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.88965 1L5.88965 5L1.88965 9" stroke="currentColor" strokeWidth="2" />
                  </svg>
                  Secure Data Management: Implement secure methods for data storage and handling, adhering to industry standards.
                </li>
              </ul>
            </div>
            <div className="data_explorebox">
              <h2 className="branding_head1">
                Data exploration & profiling
              </h2>
              <span className="sub_txt1">
                Revealing critical patterns and opportunities in your data.</span>
              <ul>
                <li>
                  <svg width="8" height="10" viewBox="0 0 8 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.88965 1L5.88965 5L1.88965 9" stroke="currentColor" strokeWidth="2" />
                  </svg>
                  Initial Data Assessment: Conduct exploratory analysis to uncover trends, patterns, and potential outliers.
                </li>
                <li>
                  <svg width="8" height="10" viewBox="0 0 8 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.88965 1L5.88965 5L1.88965 9" stroke="currentColor" strokeWidth="2" />
                  </svg>
                  Data Structure Analysis: Understand the composition and relationships within your data sets.
                </li>
                <li>
                  <svg width="8" height="10" viewBox="0 0 8 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.88965 1L5.88965 5L1.88965 9" stroke="currentColor" strokeWidth="2" />
                  </svg>
                  Preparation for Analysis: Clean, transform, and organize data for more meaningful analysis.
                </li>
              </ul>
            </div>
            <div className="data_explorebox">
              <h2 className="branding_head1">
                Dashboard & reporting solutions
              </h2>
              <span className="sub_txt1">
                Delivering clarity through intuitive, real-time dashboards.</span>
              <ul>
                <li>
                  <svg width="8" height="10" viewBox="0 0 8 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.88965 1L5.88965 5L1.88965 9" stroke="currentColor" strokeWidth="2" />
                  </svg>
                  Custom Dashboard Design: Develop intuitive dashboards that display key metrics at a glance.
                </li>
                <li>
                  <svg width="8" height="10" viewBox="0 0 8 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.88965 1L5.88965 5L1.88965 9" stroke="currentColor" strokeWidth="2" />
                  </svg>
                  Interactive Reporting: Provide interactive reports that allow stakeholders to explore data more deeply.</li>
                <li>
                  <svg width="8" height="10" viewBox="0 0 8 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.88965 1L5.88965 5L1.88965 9" stroke="currentColor" strokeWidth="2" />
                  </svg>
                  Real-Time Updates: Implement solutions for real-time data access and monitoring, keeping reports up-to-date.
                </li>
              </ul>
            </div>
            <div className="data_explorebox">
              <h2 className="branding_head1">
                Data analysis & insights
              </h2>
              <span className="sub_txt1">
                Turning raw data into strategic business insights.
              </span>
              <ul>
                <li>
                  <svg width="8" height="10" viewBox="0 0 8 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.88965 1L5.88965 5L1.88965 9" stroke="currentColor" strokeWidth="2" />
                  </svg>
                  Descriptive Analysis: Examine historical data to understand past trends and performance.
                </li>
                <li>
                  <svg width="8" height="10" viewBox="0 0 8 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.88965 1L5.88965 5L1.88965 9" stroke="currentColor" strokeWidth="2" />
                  </svg>
                  Predictive Modeling: Use advanced analytics to forecast future trends and support strategic planning.
                </li>
                <li>
                  <svg width="8" height="10" viewBox="0 0 8 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.88965 1L5.88965 5L1.88965 9" stroke="currentColor" strokeWidth="2" />
                  </svg>
                  Segmentation & Profiling: Identify distinct groups and patterns within your data for targeted insights.
                </li>
              </ul>
            </div>
            <div className="data_explorebox">
              <h2 className="branding_head1">
                Insightful data presentation
              </h2>
              <span className="sub_txt1">
                Presenting insights that drive decisions with confidence.
              </span>
              <ul>
                <li>
                  <svg width="8" height="10" viewBox="0 0 8 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.88965 1L5.88965 5L1.88965 9" stroke="currentColor" strokeWidth="2" />
                  </svg>
                  Storytelling with Data: Present data in ways that make insights clear and compelling.
                </li>
                <li>
                  <svg width="8" height="10" viewBox="0 0 8 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.88965 1L5.88965 5L1.88965 9" stroke="currentColor" strokeWidth="2" />
                  </svg>
                  Visual Data Representation: Use charts, graphs, and visual elements to simplify complex information.
                </li>
                <li>
                  <svg width="8" height="10" viewBox="0 0 8 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.88965 1L5.88965 5L1.88965 9" stroke="currentColor" strokeWidth="2" />
                  </svg>
                  Contextual Insights: Provide context around data points to guide decision-making effectively.
                </li>
              </ul>
            </div>
            <div className="data_explorebox">
              <h2 className="branding_head1">
                Performance & metrics monitoring
              </h2>
              <span className="sub_txt1">
                Tracking what matters most to your business goals.</span>
              <ul>
                <li>
                  <svg width="8" height="10" viewBox="0 0 8 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.88965 1L5.88965 5L1.88965 9" stroke="currentColor" strokeWidth="2" />
                  </svg>
                  KPI Tracking: Monitor essential KPIs to assess performance across key areas.
                </li>
                <li>
                  <svg width="8" height="10" viewBox="0 0 8 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.88965 1L5.88965 5L1.88965 9" stroke="currentColor" strokeWidth="2" />
                  </svg>
                  Trend Analysis: Observe performance trends over time to identify growth opportunities or risks.
                </li>
                <li>
                  <svg width="8" height="10" viewBox="0 0 8 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.88965 1L5.88965 5L1.88965 9" stroke="currentColor" strokeWidth="2" />
                  </svg>
                  Automated Alerts: Set up alerts for critical metrics to ensure timely response to changes.
                </li>
              </ul>
            </div>
            <div className="data_explorebox">
              <h2 className="branding_head1">
                Interpretation & insight generation
              </h2>
              <span className="sub_txt1">
                Empowering you with insights that lead to action.</span>
              <ul>
                <li>
                  <svg width="8" height="10" viewBox="0 0 8 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.88965 1L5.88965 5L1.88965 9" stroke="currentColor" strokeWidth="2" />
                  </svg>
                  Deep Analysis: Go beyond surface data to identify meaningful patterns and correlations.
                </li>
                <li>
                  <svg width="8" height="10" viewBox="0 0 8 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.88965 1L5.88965 5L1.88965 9" stroke="currentColor" strokeWidth="2" />
                  </svg>
                  Actionable Recommendations: Translate insights into practical steps that drive business outcomes.
                </li>
                <li>
                  <svg width="8" height="10" viewBox="0 0 8 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.88965 1L5.88965 5L1.88965 9" stroke="currentColor" strokeWidth="2" />
                  </svg>
                  Continuous Insight Generation: Keep insights relevant through ongoing data analysis and updates.
                </li>
              </ul>
            </div>
            <div className="data_explorebox">
              <h2 className="branding_head1">
                Collaboration & knowledge sharing
              </h2>
              <span className="sub_txt1">
                Enabling smarter collaboration through shared intelligence.
              </span>
              <ul>
                <li>
                  <svg width="8" height="10" viewBox="0 0 8 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.88965 1L5.88965 5L1.88965 9" stroke="currentColor" strokeWidth="2" />
                  </svg>
                  Data Accessibility: Ensure data is accessible to relevant teams to encourage informed collaboration.
                </li>
                <li>
                  <svg width="8" height="10" viewBox="0 0 8 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.88965 1L5.88965 5L1.88965 9" stroke="currentColor" strokeWidth="2" />
                  </svg>
                  Insight Sharing Tools: Use tools that make it easy to share insights with key stakeholders.
                </li>
                <li>
                  <svg width="8" height="10" viewBox="0 0 8 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.88965 1L5.88965 5L1.88965 9" stroke="currentColor" strokeWidth="2" />
                  </svg>
                  Cross-Departmental Integration: Facilitate data-driven decision-making across departments for cohesive growth.
                </li>
              </ul>
            </div>
            <div className="data_explorebox">
              <h2 className="branding_head1">
                Continuous refinement & iterative analysis
              </h2>
              <span className="sub_txt1">
                Ensuring your data strategy evolves with your needs.
              </span>
              <ul>
                <li>
                  <svg width="8" height="10" viewBox="0 0 8 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.88965 1L5.88965 5L1.88965 9" stroke="currentColor" strokeWidth="2" />
                  </svg>
                  Feedback Loops: Incorporate user feedback to improve analytics tools and reports.
                </li>
                <li>
                  <svg width="8" height="10" viewBox="0 0 8 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.88965 1L5.88965 5L1.88965 9" stroke="currentColor" strokeWidth="2" />
                  </svg>
                  Iterative Improvements: Continuously refine dashboards and reports based on emerging needs and trends.
                </li>
                <li>
                  <svg width="8" height="10" viewBox="0 0 8 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.88965 1L5.88965 5L1.88965 9" stroke="currentColor" strokeWidth="2" />
                  </svg>
                  Agile Analytics Approach: Adopt a flexible, iterative approach that adapts as business needs evolve.
                </li>
              </ul>
            </div>
            <div className="data_explorebox">
              <h2 className="branding_head1">
                Seamless integration with business processes
              </h2>
              <span className="sub_txt1">
                Embedding analytics into the core of your daily operations.</span>
              <ul>
                <li>
                  <svg width="8" height="10" viewBox="0 0 8 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.88965 1L5.88965 5L1.88965 9" stroke="currentColor" strokeWidth="2" />
                  </svg>
                  Data-Driven Workflow Integration: Embed analytics into daily workflows to empower data-informed decisions.
                </li>
                <li>
                  <svg width="8" height="10" viewBox="0 0 8 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.88965 1L5.88965 5L1.88965 9" stroke="currentColor" strokeWidth="2" />
                  </svg>
                  Process Alignment: Align analytics solutions with business objectives for consistent value delivery.
                </li>
                <li>
                  <svg width="8" height="10" viewBox="0 0 8 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.88965 1L5.88965 5L1.88965 9" stroke="currentColor" strokeWidth="2" />
                  </svg>
                  Scalable Solutions: Build BI tools that grow with your organization’s needs and capabilities.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      <section className="why_hireapp">
        <div className="container">
          <div className="why_hireappinner">
            <div className="why_hireleft">
              <div className="common_titbox"><h2 className="common_hd">Self-Service BI and data democratization</h2><p className="common_desc">Empower your teams to access, interpret, and act on data independently with our self-service BI solutions. We implement easy-to-use tools that enable employees at all levels to generate their own reports and insights, making data-driven culture a reality across the organization.</p></div>
            </div>
            <div className="why_hirergt">
              <div className="why_hirergtlist">
                <div className="icons_bx">
                  <Image
                    src={InsightfulDataVisualizationIco}
                    alt="Insightful data visualization" />
                </div>
                <div className="bxright_cont">
                  <h3 className="bx_righthd">Insightful data visualization</h3>
                  <p className="bx_rightdesc">Navigate complex datasets with ease using our powerful data visualization tools. We convert intricate data into clear, intuitive visuals that bring actionable insights to light, helping you see your business metrics in a new way.</p>
                </div>
              </div>
              <div className="why_hirergtlist">
                <div className="icons_bx">
                  <Image
                    src={IntegratedAdvancedAnalyticsIco}
                    alt="Integrated advanced analytics" />
                </div>
                <div className="bxright_cont">
                  <h3 className="bx_righthd">Integrated advanced analytics</h3>
                  <p className="bx_rightdesc">Empower your decision-making with seamlessly integrated advanced analytics. Harness the power of AI to reveal predictive insights, equipping you with proactive strategies to drive business growth.</p>
                </div>
              </div>
              <div className="why_hirergtlist">
                <div className="icons_bx">
                  <Image
                    src={RealTimeMetricsDynamicDashboardsIco}
                    alt="Real-time metrics & dynamic dashboards" />
                </div>
                <div className="bxright_cont">
                  <h3 className="bx_righthd">Real-time metrics & dynamic dashboards</h3>
                  <p className="bx_rightdesc">Stay in control with real-time reporting and dynamic dashboards. Track essential KPIs and business metrics in real-time, empowering you to adapt swiftly to shifts in market conditions.</p>
                </div>
              </div>
              <div className="why_hirergtlist">
                <div className="icons_bx">
                  <Image
                    src={StrategicInsightsAataDrivenPlanningIco}
                    alt="Strategic insights & data-driven planning" />
                </div>
                <div className="bxright_cont">
                  <h3 className="bx_righthd">Strategic insights & data-driven planning</h3>
                  <p className="bx_rightdesc">Build stronger business strategies with our data-driven approach. We support you in uncovering actionable insights from your data, ensuring your organization remains informed and strategically aligned at every step.</p>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>
      <section className="industry_bg1">
        <div className="container industry_containerouter1">
          <div className="common_titbox common_titboxcenter"><h2 className="common_hd">Why Choose iKnot?</h2>
          </div>
          <IndustryComponent />
        </div>
      </section>
      <section className="cta_outer cta_outerhome">
        <div className="container cta_container">
          <div className="cta_inner">
            <div className="cta_innerout1">
              <div className="cta_left1">
                <h3 className="cta_hd">Ready to unlock the full potential of your business?</h3>
                <p className="cta_desc">Get in touch with our experts to unlock advanced analytics using BI tools, driving smarter decisions and business growth!</p>
                <div className="banner_btn_container">
                  <StartTrialBtn Text={"Get Started"} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


    </>
  );
}
